<template>
  <v-container>
    <v-data-table

        :headers="headers"
        :items="this.$store.state.teams"
        :items-per-page="50"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        dense
        class="elevation-1"
        hide-default-footer
        disable-pagination
        mobile-breakpoint="100"
    >
      <template v-slot:item.name="{ item }">
        <span>
          {{ item.name }}
        </span>
        <span v-if="item.greenFleet" class="greenLabel">green</span>
      </template>
      <template v-slot:item.skippers="{ item }">
        <span v-for="(skipper,index) in item.skippers" v-bind:key="skipper">{{skipper}}
          <span v-if="index<item.skippers.length-1">, </span>
        </span>

      </template>

    </v-data-table>
  </v-container>
</template>

<script>

export default {

  data: () => ({
    headers: [
      {text: 'Place', value: 'place'},
      {text: 'Name', value: 'name'},
      {text: 'Skippers', value: 'skippers'},
    /*  {text: 'Initial seed', value: 'initialSeed'},
      {text: 'Seed', value: 'seed'},
      {text: 'Tiebreaker', value: 'tiebreaker'},*/
      {text: 'L', value: 'losses'},
      {text: 'W', value: 'wins'},
    ],
    sortBy: 'place',
    sortDesc: false,
  }),

}
</script>

<style>
.greenLabel{
  background-color: green;
  padding:2px;
  border-radius: 2px;
  color:white;
  text-transform: uppercase;
  font-size:10px;

}
</style>